import { AppThunk } from "../app/store";
import { getProductLinesForUser } from "../app/api";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductLine } from "@amzn/coral_com-amazon-programproductlineservice";

type ProductLinesState = {
  status?: "pending" | "loading" | "finished" | "error";
  values: ProductLine[];
  error?: string;
};

type ProductLinesData = {
  productLinesData: ProductLinesState;
};

const ProductLinesInitialData: ProductLinesData = {
  productLinesData: { values: [] },
};

const productLinesData = createSlice({
  name: "productLinesData",
  initialState: ProductLinesInitialData,
  reducers: {
    getProductLinesStarted(state) {
      state.productLinesData.status = "loading";
    },
    getProductLinesSuccess(state, action: PayloadAction<ProductLine[]>) {
      state.productLinesData.status = "finished";
      state.productLinesData.values = action.payload;
    },
    getProductLinesFailure(state, action) {
      state.productLinesData.status = "error";
      state.productLinesData.error = action.payload;
    },
  },
});

export const {
  getProductLinesStarted,
  getProductLinesSuccess,
  getProductLinesFailure,
} = productLinesData.actions;

export default productLinesData.reducer;

export const getProductLines = (): AppThunk => async (dispatch) => {
  try {
    dispatch(getProductLinesStarted());
    const productLines = await getProductLinesForUser();
    dispatch(getProductLinesSuccess(productLines));
  } catch (err: unknown) {
    const errorMessage = err instanceof Error ? err.message : String(err);
    dispatch(getProductLinesFailure(errorMessage));
  }
};
